import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  const scrollToCTA = () => document.getElementById('final-cta')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="relative pt-8 md:pt-12 pb-32 px-4 overflow-hidden" data-id="element-29" data-mp="4lqj4w64bd3i">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-900/20 via-background to-background -z-10" data-id="element-30" data-mp="4jm4bj6oktog" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 md:items-center" data-id="element-31" data-mp="xbfkxbqnjh66">
        {/* Left column: headline, subheadline, CTA (desktop) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center md:text-left" data-id="element-32" data-mp="ncgk2fc4optq">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-33" data-mp="3j8sd1u7lx7mo">
            The Year Isn't Over.
            <br data-id="element-34" data-mp="3o6ar1z0hed1j" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-35" data-mp="3o6u6n92nspce">
              It's Just Getting Started.
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-10 max-w-2xl mx-auto md:mx-0 leading-relaxed" data-id="element-36" data-mp="3e84rho25dizu">
            The Science-Backed Blueprint to Obliterate Brain Fog, Reset Your
            Hormones, and Dominate the Second Half of 2026 with Unstoppable
            Energy.
          </p>

          {/* Desktop-only CTA + badge (mobile version sits below the image) */}
          <div className="hidden md:block" data-id="element-37" data-mp="2vi55xb5imm16">
            <Button className="text-lg md:text-xl px-10 py-5 mb-8" onClick={scrollToCTA} data-id="element-38" data-mp="2vgu0z80c388h">
              RECLAIM MY EDGE FOR THE SECOND HALF →
            </Button>

            <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-39" data-mp="2lmv4aoj14gnx">
              <ShieldCheck className="w-5 h-5 text-green-500 shrink-0" data-id="element-40" data-mp="s3co0h6r7vtq" />
              <span data-id="element-41" data-mp="najgxmntcbeh">
                Join 2,400+ Professionals Optimizing Their Biology for a
                Powerful 2026 Finish
              </span>
            </div>
          </div>
        </motion.div>

        {/* Right column: bundle image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="flex justify-center" data-id="element-42" data-mp="1b0vwnjpavcfm">
          <img src="https://cdn.magicpatterns.com/uploads/gLSQe1J76oqZBuGM7qkkxs/Foto_para_Landing_page.png" alt="The Biologic Edge product bundle featuring The Brain Killer, The Biologic Edge manual, and The 7-Day Reset" className="w-full h-auto max-w-lg object-contain drop-shadow-[0_0_45px_rgba(80,200,120,0.45)]" data-id="element-43" data-mp="x1nvwmdhnw9b" />
        </motion.div>

        {/* Mobile-only CTA + badge (appears below the image) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:hidden text-center" data-id="element-44" data-mp="218to7r4wn2cr">
          <Button className="text-lg px-10 py-5 mb-8 w-full sm:w-auto" onClick={scrollToCTA} data-id="element-45" data-mp="2g2566qxfmsxs">
            RECLAIM MY EDGE FOR THE SECOND HALF →
          </Button>

          <div className="flex items-center justify-center gap-2 text-gray-400 text-sm font-medium" data-id="element-46" data-mp="2oyo1uax1suy2">
            <ShieldCheck className="w-5 h-5 text-green-500 shrink-0" data-id="element-47" data-mp="umhc873eqbm8" />
            <span data-id="element-48" data-mp="uoallu5en9xx">
              Join 2,400+ Professionals Optimizing Their Biology for a Powerful
              2026 Finish
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}